
import React from 'react';
import actions from '../actions/UsTodniKamkarAction';
import Avatar from 'react-avatar';
var constants = require("../constants/constants");
var axios = require('axios');
var trstyle = {
    float: 'right',
    margin: '10px 10px 0px 0px'
}
export default class UsTodKamgaranchiMahiti extends React.Component {
    constructor(props) {
        super(props);
        let CompanyId = localStorage.getItem('CompanyId') || 1;
        this.state = {
            MukadamName: props.location.isEditCall ? props.location.editKamgarData.MukadamId : '',
            WorkarId: props.location.isEditCall ? props.location.editKamgarData.WorkarId : '',
            fname: props.location.isEditCall ? props.location.editKamgarData.FirstName : '',
            mname: props.location.isEditCall ? props.location.editKamgarData.MiddleName : '',
            lname: props.location.isEditCall ? props.location.editKamgarData.LastName : '',
            gender: props.location.isEditCall ? props.location.editKamgarData.Gender : '',
            addr: props.location.isEditCall ? props.location.editKamgarData.Address : '',
            village: props.location.isEditCall ? props.location.editKamgarData.Village : '',
            Taluka: props.location.isEditCall ? props.location.editKamgarData.Taluka : '',
            Distric: props.location.isEditCall ? props.location.editKamgarData.Distric : '',
            States: props.location.isEditCall ? props.location.editKamgarData.States : '',
            pincode: props.location.isEditCall ? props.location.editKamgarData.Pincode : '',
            contact: props.location.isEditCall ? props.location.editKamgarData.ContactNo : '',
            AlteNativecontact: props.location.isEditCall ? props.location.editKamgarData.AlteNativecontact = '0' : '',
            AdharCardNo: props.location.isEditCall ? props.location.editKamgarData.AdharCardNo : '',
            userPhoto: props.location.isEditCall ? props.location.editKamgarData.userPhoto : 'images/img_avatar.png',
            TalukaList: [],
            DistrictList: [],
            MukadamDetails: [],
            CompanyId: CompanyId,
        };
        this.onImageChange.bind(this)
    }
    componentWillMount() {
        let currentComponent = this;
        var user = JSON.parse(sessionStorage.getItem("User"));
        axios.get(constants.config.HOST + constants.api.GET_DISTRICLIST, {
        }).then(function (response) {
            currentComponent.setState({ DistrictList: response.data })
            console.log(response.data)
        }).catch(function (error) {
            console.log(error);
        })
        axios.get(constants.config.HOST + constants.api.GET_TALUKALIST, {
        }).then(function (response) {
            currentComponent.setState({ TalukaList: response.data })
            console.log(response.data)
        }).catch(function (error) {
            console.log(error);
        });
        axios.get(constants.config.HOST + constants.api.GET_MUKADAMLIST, {
            params: { CompanyId: localStorage.getItem('CompanyId') || 1, TransportersId: user.TransportersId }
        }).then(function (response) {
            currentComponent.setState({ MukadamDetails: response.data })
            console.log(response.data)
        }).catch(function (error) {
            console.log(error);
        });
    }

    addKamgar(e) {
        e.preventDefault();
        if (this.validation())
            actions.addKamgar(this.state);
        else
            return false;
        this.props.history.push('/KamgarFillInfo_Show_Details')
    }

    UpdateKamgar(e) {
        e.preventDefault();
        actions.UpdateKamgar(this.state);
        this.props.history.push('/KamgarFillInfo_Show_Details')
    }

    handleInputChangeFile(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.files[0];
        this.setState(state);
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    onImageChange(event) {
        console.log('On Image change')
        var selectedFile = event.target.files;
        if (event.target.files && event.target.files[0]) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.setState({ userPhoto: e.target.result, selectedUserPhoto: selectedFile[0] });
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    selectImage(e) {
        e.preventDefault();
        this.myInput.click()
    }

    validation() {
        var validator = true;
        var errmsg = '';
        // remove already error element
        try {
            var elements = document.getElementsByClassName('help-block');
            while (elements.length > 0) {
                elements[0].parentNode.removeChild(elements[0]);
            }
        } catch (e) {
        }
        //validation code start

        var form = document.getElementById('theForm');
        for (var i = 0; i < form.elements.length; i++) {
            if (form.elements[i].value === '' && form.elements[i].hasAttribute('required')) {
                errmsg = '';
                errmsg = form.elements[i].getAttribute("data-msg");
                if (errmsg !== '') {
                    var ele = document.createElement("span");
                    ele.classList.add('help-block');
                    ele.textContent = errmsg;
                    form.elements[i].parentElement.appendChild(ele);
                }
                form.elements[i].parentElement.classList.add("has-error");
                validator = false;
            }
            else {
                form.elements[i].parentElement.classList.remove("has-error")
            }
        }
        return validator;
    }

    render() {
        let currentComponent = this;
        let mukadamName = this.state.MukadamDetails.find(function (MukadamName) {
            return MukadamName.MukadamId === currentComponent.state.MukadamName
        });
        let distric = this.state.DistrictList.find(function (district) {
            return district.DistrictId === currentComponent.state.Distric
        });
        let taluka = this.state.TalukaList.find(function (Taluka) {
            return Taluka.TalukaId === currentComponent.state.Taluka
        });

        return (
            <div className="pages">
                <div data-page="form" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div className="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                            <div className="navbar_right">
                                <a href="/UserProfile" className="external"><img src="images/icons/white/user.png" alt="" title="" /></a>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <div className="page_single layout_fullwidth_padding">

                                <div className="contactform">
                                    <form className="" id="CustomForm" method="post" action="">
                                        <h3 style={{ 'color': '#0000FF' }} >ऊस तोडणी कामगाराची माहिती</h3>
                                        <div>
                                            <Avatar src={this.state.userPhoto !== '' ? this.state.userPhoto : "images/img_avatar.png"} id="userPhoto" name="userPhoto" data-msg=" **** फोटो  आवश्यक ***" required />
                                        </div>
                                        <div>
                                            <input id="myInput" type="file"
                                                ref={(ref) => this.myInput = ref}
                                                onChange={(e) => this.onImageChange(e)}
                                                style={{ display: 'none' }} data-msg=" **** फोटो  आवश्यक ***" />
                                            <button className="btn  btn-primary" onClick={(e) => this.selectImage(e)}>Upload photo</button>
                                        </div>
                                        <form id="theForm">
                                            <fieldset>
                                                <div className="form_row custom_select">
                                                    <a href=" " className="item-link smart-select" data-open-in="picker">
                                                        <div className="item-content">
                                                            <div className="item-inner">
                                                                <label >मुकादमाची नावे :</label>
                                                                <div className="item-after">{mukadamName === undefined ? 'Select' : mukadamName.fullname}</div>
                                                            </div>
                                                        </div>
                                                        <select defaultValue={this.state.selectValue}
                                                            onChange={this.handleChange} id='MukadamName' className="required" name='MukadamName' value={this.state.MukadamName} onChange={(e) => this.handleInputChange(e)}>
                                                            <option value="0">Selected</option>
                                                            {
                                                                this.state.MukadamDetails.map(MukadamName => <option value={MukadamName.MukadamId}>{MukadamName.fullname}</option>)
                                                            }
                                                        </select>
                                                    </a>
                                                </div >
                                                <div className="form_row">
                                                    <label htmlFor="fname">पहिले नाव :</label>
                                                    <input type="text" className="form_input" id="fname" name="fname" data-msg=" **** पहिले नाव आवश्यक ***" value={this.state.fname} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="पहिले नाव भरा" required />
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="mname">मधले नाव :</label>
                                                    <input type="text" className="form_input" id="mname" name="mname" data-msg=" **** मधिले नाव आवश्यक ***" value={this.state.mname} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="मधिले नाव भरा" required />
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="lname">आडनाव :</label>
                                                    <input type="text" className="form_input" id="lname" name="lname" data-msg=" **** आडनाव आवश्यक ***" value={this.state.lname} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="आडनाव भरा" required />
                                                </div>
                                                <div className="form_row custom_select">
                                                    <a href=" " className="item-link smart-select" data-open-in="picker">
                                                        <div className="item-content">
                                                            <div className="item-inner">
                                                                <label>Gender :</label>
                                                                <div className="item-after">Select</div>
                                                            </div>
                                                        </div>
                                                        <select id='gender' className="required" name='gender' value={this.state.gender} onChange={(e) => this.handleInputChange(e)}>
                                                            <option value="0">Select</option>
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                        </select>
                                                    </a>
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="addr">पता :</label>
                                                    <input type="text" className="form_input" id="addr" name="addr" data-msg=" **** पता आवश्यक ***" value={this.state.addr} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="पता भरा" required />
                                                </div>
                                                <div className="form_row custom_select">
                                                    <a href=" " className="item-link smart-select" data-open-in="picker">
                                                        <div className="item-content">
                                                            <div className="item-inner">
                                                                <label>जिल्हा नाव :</label>
                                                                <div className="item-after">{distric === undefined ? 'Select' : distric.DistrictName}</div>
                                                            </div>
                                                        </div>
                                                        <select id='Distric' className="required" name='Distric' value={this.state.District} onChange={(e) => this.handleInputChange(e)}>
                                                            <option value="0">Select</option>
                                                            {
                                                                this.state.DistrictList.map(district => <option value={district.DistrictId}>{district.DistrictName}</option>)
                                                            }
                                                        </select>
                                                    </a>
                                                </div>
                                                <div className="form_row custom_select">
                                                    <a href=" " className="item-link smart-select" data-open-in="picker">
                                                        <div className="item-content">
                                                            <div className="item-inner">
                                                                <label>तालुका  नाव :</label>
                                                                <div className="item-after">{taluka === undefined ? 'Select' : taluka.TalukaName}</div>
                                                            </div>
                                                        </div>

                                                        <select id='Taluka' className="required" name='Taluka' value={this.state.Taluka} onChange={(e) => this.handleInputChange(e)}>
                                                            <option value="0">Select</option>
                                                            {
                                                                this.state.TalukaList.map(Taluka => <option value={Taluka.TalukaId}>{Taluka.TalukaName}</option>)
                                                            }
                                                        </select>
                                                    </a>
                                                </div >

                                                <div className="form_row">
                                                    <label>गावाचे नाव :</label>
                                                    <input type="text" className="form_input" id="village" name="village" data-msg=" **** गावाचे नाव आवश्यक ***" value={this.state.village} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="गावाचे नाव भरा" required />
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="States">राज्याचे  नाव :</label>
                                                    <input type="text" className="form_input" id="State" name="States" data-msg=" **** राज्याचे नाव आवश्यक ***" value={this.state.States} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="राज्याचे नाव भरा " required />
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="pincode">गावाचा पिनकोड :</label>
                                                    <input type="Number" className="form_input" id="pincode" name="pincode" data-msg=" **** गावाचा पिनकोड आवश्यक ***" value={this.state.pincode}
                                                        onChange={(e) => this.handleInputChange(e)} placeholder="गावाचा पिनकोड भरा" required />
                                                </div>
                                                <div className="col-15">
                                                    <label htmlFor="contact">मोबाईल नंबर :</label>
                                                    <input type="Number" className="form_input" id="contact" name="contact" data-msg=" **** मोबाईल न. आवश्यक ***" value={this.state.contact} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="मोबाईल न.भरा" required />
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="AdharCardNo">आधार कार्ड नंबर :</label>
                                                    <input type="Number" className="form_input" id="AdharCardNo" name="AdharCardNo" data-msg=" **** आधार कार्ड न. आवश्यक ***" value={this.state.AdharCardNo} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="आधार कार्ड न. भरा " required />
                                                </div>
                                                <div className="form-group">
                                                    {this.props.location.isEditCall ? <button className="btn  btn-primary" style={trstyle} type="submit" onClick={(e) => this.UpdateKamgar(e)}>Update करा </button>
                                                        : <button className="btn  btn-primary" type="submit" style={trstyle} onClick={(e) => this.addKamgar(e, currentComponent.state.CompanyId)}>✔ Save करा </button>}
                                                </div>
                                            </fieldset>
                                        </form>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}






// WEBPACK FOOTER //
// ./src/component/UsTodKamgaranchiMahiti.jsx